var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5F62\u72B6\u7ED3\u5408") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-785.000000, -774.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M786,774 L800,774 C800.552285,774 801,774.447715 801,775 C801,775.552285 800.552285,776 800,776 L786,776 C785.447715,776 785,775.552285 785,775 C785,774.447715 785.447715,774 786,774 Z M788,779 L798,779 C798.552285,779 799,779.447715 799,780 C799,780.552285 798.552285,781 798,781 L788,781 C787.447715,781 787,780.552285 787,780 C787,779.447715 787.447715,779 788,779 Z M791,784 L795,784 C795.552285,784 796,784.447715 796,785 C796,785.552285 795.552285,786 795,786 L791,786 C790.447715,786 790,785.552285 790,785 C790,784.447715 790.447715,784 791,784 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon_filter.c3b9f2439d6eba7d55d66ca89331c90c.svg";
export { ForwardRef as ReactComponent };